import { Translation } from 'cng-common/features/translations/components/translation'
import { ITableColumn } from 'partner360/components/financialTable'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { IQBRPlanAchievementDependOnSettings } from 'partner360/models/qbr/IQBRPlanAchievementDependOnSettings'
import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

import { QbrQuarters } from '../../../../../../models/qbrQuarters'
import styles from '../PlanAchievement.module.scss'

import { getMoneyShortedViewCell } from './getMoneyShortedViewCell'

interface IGetColumnsMoneyShortedViewParameters {
  rounding: QBRRounding
  currentFYear: number
  selectedPeriodFQuarters: number[]
}

export const getColumnsMoneyShortedView = ({
  currentFYear,
  rounding,
  selectedPeriodFQuarters,
}: IGetColumnsMoneyShortedViewParameters): ITableColumn<IQBRPlanAchievementDependOnSettings>[] => {
  const previousFYear = currentFYear - 1
  const previousFYearLastTwoDigits = previousFYear.toString().slice(-2)

  const previousYearColumns: ITableColumn<IQBRPlanAchievementDependOnSettings>[] = [
    {
      key: 'name',
      title: 'Name',
      renderFn: () => {
        return (
          <div className={styles.financialValueShortedView}>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.actual} />
            </p>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.plan} />
            </p>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.actToPlan} />
            </p>
            <p className={styles.paragraph}>
              <Translation span text={TRANSLATION_KEYS.financialTable.yoy} />
            </p>
          </div>
        )
      },
    },
    {
      key: `${previousFYear} Q1`,
      title: `Q1'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.PrevYearQ1Actuals,
          plans: item.PrevYearQ1Plans,
          actualsToPlans: item.PrevYearQ1ActualsToPlans,
          yoyActuals: item.PrevYearQ1YoYActuals,
          rounding,
        })
      },
    },
    {
      key: `${previousFYear} Q2`,
      title: `Q2'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.PrevYearQ2Actuals,
          plans: item.PrevYearQ2Plans,
          actualsToPlans: item.PrevYearQ2ActualsToPlans,
          yoyActuals: item.PrevYearQ2YoYActuals,
          rounding,
        })
      },
    },
    {
      key: `${previousFYear} Q3`,
      title: `Q3'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.PrevYearQ3Actuals,
          plans: item.PrevYearQ3Plans,
          actualsToPlans: item.PrevYearQ3ActualsToPlans,
          yoyActuals: item.PrevYearQ3YoYActuals,
          rounding,
        })
      },
    },
    {
      key: `${previousFYear} Q4`,
      title: `Q4'${previousFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.PrevYearQ4Actuals,
          plans: item.PrevYearQ4Plans,
          actualsToPlans: item.PrevYearQ4ActualsToPlans,
          yoyActuals: item.PrevYearQ4YoYActuals,
          rounding,
        })
      },
    },
  ]
  const currentYearColumns: ITableColumn<IQBRPlanAchievementDependOnSettings>[] = []
  const currentFYearLastTwoDigits = currentFYear.toString().slice(-2)

  if (selectedPeriodFQuarters.includes(QbrQuarters.Q1)) {
    currentYearColumns.push({
      key: `${currentFYear} Q1`,
      title: `Q1'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.CurrentYearQ1Actuals,
          plans: item.CurrentYearQ1Plans,
          actualsToPlans: item.CurrentYearQ1ActualsToPlans,
          yoyActuals: item.CurrentYearQ1YoYActuals,
          rounding,
        })
      },
    })
  }
  if (selectedPeriodFQuarters.includes(QbrQuarters.Q2)) {
    currentYearColumns.push({
      key: `${currentFYear} Q2`,
      title: `Q2'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.CurrentYearQ2Actuals,
          plans: item.CurrentYearQ2Plans,
          actualsToPlans: item.CurrentYearQ2ActualsToPlans,
          yoyActuals: item.CurrentYearQ2YoYActuals,
          rounding,
        })
      },
    })
  }
  if (selectedPeriodFQuarters.includes(QbrQuarters.Q3)) {
    currentYearColumns.push({
      key: `${currentFYear} Q3`,
      title: `Q3'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.CurrentYearQ3Actuals,
          plans: item.CurrentYearQ3Plans,
          actualsToPlans: item.CurrentYearQ3ActualsToPlans,
          yoyActuals: item.CurrentYearQ3YoYActuals,
          rounding,
        })
      },
    })
  }
  if (selectedPeriodFQuarters.includes(QbrQuarters.Q4)) {
    currentYearColumns.push({
      key: `${currentFYear} Q4`,
      title: `Q4'${currentFYearLastTwoDigits}`,
      renderFn: (item) => {
        return getMoneyShortedViewCell({
          actuals: item.CurrentYearQ4Actuals,
          plans: item.CurrentYearQ4Plans,
          actualsToPlans: item.CurrentYearQ4ActualsToPlans,
          yoyActuals: item.CurrentYearQ4YoYActuals,
          rounding,
        })
      },
    })
  }

  return [...previousYearColumns, ...currentYearColumns]
}
